import React, { useRef, useEffect, useState } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from './Navbar';  // Importa tu componente de navegación
import Footer from './Footer';  // Importa tu componente de pie de página


import pozo from '../assets/img_1.jpg';

import perforaciones_1 from '../assets/foto1.jpg';
import perforaciones_2 from '../assets/foto2.JPG';
import perforaciones_3 from '../assets/foto3.JPG';
import perforaciones_4 from '../assets/foto4.JPG';

import pozo_agua from '../assets/img_2.jpg';

function Perforaciones() {
    const [startCount, setStartCount] = useState(false);
    const refMetrica = useRef(null);

    useEffect(() => {
        AOS.init({ duration: 1200 });

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStartCount(true);
                } else {
                    setStartCount(false);
                }
            },
            {
                threshold: 0.5,
            }
        );
        if (refMetrica.current) {
            observer.observe(refMetrica.current);
        }
        return () => {
            if (refMetrica.current) {
                observer.unobserve(refMetrica.current);
            }
        };
    }, []);

    return (
        <div>


            {/* Contenido principal de Perforaciones */}

            {/* Sección de Perforaciones Unificada */}
            {/* Sección de Perforaciones Unificada */}
            <section
                id="proceso"
                className="relative py-16 w-full shadow-lg overflow-hidden bg-no-repeat bg-cover perforation-background mt-20"
                data-aos="fade-up"
                data-aos-duration="1000"
            >
                {/* Contenido */}
                <div className="relative text-center mb-12 max-w-6xl mx-auto px-4">
                    {/* Título principal */}
                    <h2
                        className="font-extrabold text-4xl leading-tight tracking-tight text-white mb-4"
                       // style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.2' }}
                        data-aos="fade-down"
                        data-aos-delay="200"
                    >
                        Etapas del Proceso
                    </h2>

                    {/* Línea conectiva */}
                    <div className="h-1 w-16 bg-white mb-6 mx-auto"></div>

                    {/* Contenedor de las tarjetas */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-4 lg:px-16">

                        {/* Tarjeta 1 */}
                        <div className="relative p-0 rounded-none overflow-hidden transition-transform transform hover:scale-105">
                            <img
                                src={perforaciones_1}
                                alt="Selección del punto"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 hover:bg-opacity-30 transition-colors duration-300">
                                <div className="text-center text-white px-4">
                                    <h3 className="font-bold text-3xl mb-4">Selección del Punto</h3>
                                    <p className="text-md leading-relaxed">
                                        Basados en estudios geoeléctricos y análisis previos, se selecciona el punto óptimo para iniciar la perforación.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Tarjeta 2 */}
                        <div className="relative p-0 rounded-none overflow-hidden transition-transform transform hover:scale-105">
                            <img
                                src={perforaciones_2}
                                alt="Perforación exploratoria"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 hover:bg-opacity-30 transition-colors duration-300">
                                <div className="text-center text-white px-4">
                                    <h3 className="font-bold text-3xl mb-4">Perforación Exploratoria</h3>
                                    <p className="text-md leading-relaxed">
                                        Se realiza la perforación hasta la profundidad predeterminada para luego realizar un perfilaje eléctrico.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Tarjeta 3 */}
                        <div className="relative p-0 rounded-none overflow-hidden transition-transform transform hover:scale-105">
                            <img
                                src={perforaciones_3}
                                alt="Instalación de tuberías"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 hover:bg-opacity-30 transition-colors duration-300">
                                <div className="text-center text-white px-4">
                                    <h3 className="font-bold text-3xl mb-4">Diseño de entubación</h3>
                                    <p className="text-md leading-relaxed">
                                        En base al perfilaje y las muestras obtenidas se procede con el diseño y entubación del pozo.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Tarjeta 4 */}
                        <div className="relative p-0 rounded-none overflow-hidden transition-transform transform hover:scale-105">
                            <img
                                src={perforaciones_4}
                                alt="Pruebas y Validación"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 hover:bg-opacity-30 transition-colors duration-300">
                                <div className="text-center text-white px-4">
                                    <h3 className="font-bold text-3xl mb-4">Finalización</h3>
                                    <p className="text-md leading-relaxed">
                                        Luego de ser entubado se procede a la limpieza y acondicionamiento de la perforación.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


        </div>
    );

}

export default Perforaciones;